export enum FormTypeEnum {
  Individual,
  Business,
  Introducer,
}
